import { render, staticRenderFns } from "./HomeMetrics.vue?vue&type=template&id=5b53cf12"
import script from "./HomeMetrics.vue?vue&type=script&lang=js"
export * from "./HomeMetrics.vue?vue&type=script&lang=js"
import style0 from "./HomeMetrics.vue?vue&type=style&index=0&id=5b53cf12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports